// themes.js
export const themes = {
  switchgear: {
    name: 'SwitchGear',
    background: '#ffffff',
    text: '#000000',
    primary: '#1976d2',
    header_background: '#2f4f4f',
    header_text: '#ffffff',
    footer_background: '#f0f0f0',
    footer_text: '#333333'
  },
  rail: {
    name: 'Rail',
    background: '#ffffff',
    text: '#000000',
    primary: '#1976d2',
    header_background: '#8b2f2f',
    header_text: '#ffffff',
    footer_background: '#f0f0f0',
    footer_text: '#333333'
  },
  system: {
    name: 'System',
    background: '#f0f0f0',
    text: '#333333',
    primary: '#007bff',
    header_background: '#424242',
    header_text: '#ffffff',
    footer_background: '#f0f0f0',
    footer_text: '#333333'
  },
  default: {
    name: 'Default',
    background: '#f0f0f0',
    text: '#333333',
    primary: '#007bff',
    header_background: '#424242',
    header_text: '#ffffff',
    footer_background: '#f0f0f0',
    footer_text: '#333333'
  }
}
